import $ from "jQuery";

export default () => {
  $(document).on("keydown", (e) => {
    var code = e.keyCode ? e.keyCode : e.which;

    // ESC behaviors
    if (code == 27) {
    }

    // TAB behaviors
    if (!e.shiftKey && code == 9) {
    }

    // SHIFT + TAB behaviors
    if (e.shiftKey && code == 9) {
    }

    // ENTER behaviors
    if (code == 13) {
      // selects the focused checkbox
      if ($(".form-checkbox").is(":focus")) {
        $(".form-checkbox:focus").trigger("click");
      }

      // selects the focused radio
      if ($(".form-radio").is(":focus")) {
        $(".form-radio:focus").trigger("click");
      }

      // selects the focused facets checkbox
      if ($(".facets-checkbox").is(":focus")) {
        $(".facets-checkbox:focus").trigger("click");
      }

      // selects the focused facets radio
      if ($(".facets-radio").is(":focus")) {
        $(".facets-radio:focus").trigger("click");
      }
    }
  });
};
